export const missionObjectExtensionName = 'mission_object_extension'
export const missionObjectFieldName = 'MISSION_OBJECT'
export const missionObjectOrThisFieldName = 'MISSION_OBJECT_OR_THIS'
